import React, {useRef, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {PromotionBenefitList} from "./_list";
import {PromotionBenefitForm} from "./_form";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/promo/promotionActions";
import {connect} from "react-redux";


const PromotionBenefit = (props) => {
    const { domainObject } = props.formProps;

    const [promotion] = useState(domainObject);
    const [editMode] = useState(false);
    const [item, setItem] = useState();

    const refForm = useRef(null);
    const refList = useRef(null);

    const setForm = () => {
        //props.setForm(null, null, "LIST");
        props.setItem(null);
        props.setForm();
        props.setViewMode("LIST");
    }

    const updateItem = (item) => {
        setItem(item)
    }

    const refreshList = () => {
        refList.current.refreshList();
    }

    return (
        <div>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario */}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <PromotionBenefitForm setForm={setForm} updateItem={updateItem} refreshList={refreshList} item={item}
                                        promotion={promotion} editMode={editMode} ref={refForm}/>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado */}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <PromotionBenefitList setForm={setForm} promotion={promotion} ref={refList}/>
                </Col>
            </Row>

        </div>
    );
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionBenefit)
